<div class="table-container">
    <table>
        <thead>
            <tr>
                <th colspan="2" class="center">{{ league?.type === 'MULTI_WEEK_LEAGUE' || league?.type === 'LEAGUE' || !league?.type ? 'Week Details' : 'Course Details' }}</th>
            </tr>
        </thead>
        <tbody> 
            <tr>
                <td>Starts</td>
                <td>{{ formatDate(leagueWeek?.weekStartDate) }} </td>
            </tr>
            <tr>
                <td>Ends</td>
                <td>{{ formatDate(leagueWeek?.weekEndDate) }} </td>
            </tr>
            <tr>
                <td>Course Par</td>
                <td>{{ leagueWeek?.coursePar }} </td>
            </tr>
            <tr>
                <td>Rounds to Count</td>
                <td>{{ leagueWeek?.roundsToCount}} </td>
            </tr>
            <tr>
                <td>Max Rounds to Post</td>
                <td>{{ leagueWeek?.maxRoundsToPost}} </td>
            </tr>
            <tr>
                <td>Using Handicaps</td>
                <td>{{ formatYesNo(league?.useHandicaps) }} </td>
            </tr>
            <tr>
                <td colspan="2" class="center dark-row"><strong>GS Pro Settings</strong></td>
            </tr>
            <tr>
                <td>Holes To Play</td>
                <td>{{ formatHolesToPlay(leagueWeek?.holesToPlay) }}</td>
            </tr>
            <tr>
                <td>Tees</td>
                <td>{{ leagueWeek?.teeLocation }}</td>
            </tr>
            <tr>
                <td>Pins</td>
                <td>{{ leagueWeek?.pinLocations }}</td>
            </tr>
            <tr>
                <td>Gimme Circle</td>
                <td>{{ leagueWeek?.gimmeCircleSize }} ft.</td>
            </tr>
        </tbody>
    </table>
</div>
<button *ngIf="canEdit" (click)="edit.emit()">{{ editLabel }}</button>
